__turbopack_context__.v({
  "attributeKey": "jpCLRW_attributeKey",
  "attributeType": "jpCLRW_attributeType",
  "attributes": "jpCLRW_attributes",
  "attributesContainer": "jpCLRW_attributesContainer",
  "attributesLink": "jpCLRW_attributesLink",
  "contentRow": "jpCLRW_contentRow",
  "description": "jpCLRW_description",
  "fadeIn": "jpCLRW_fadeIn",
  "header": "jpCLRW_header",
  "highlightedFromCode": "jpCLRW_highlightedFromCode",
  "label": "jpCLRW_label",
  "labelDeprecated": "jpCLRW_labelDeprecated",
  "labelRequired": "jpCLRW_labelRequired",
  "nestedTable": "jpCLRW_nestedTable",
  "noSeparator": "jpCLRW_noSeparator",
  "offsetAnchor": "jpCLRW_offsetAnchor",
  "schemaRow": "jpCLRW_schemaRow",
  "scrollyBit": "jpCLRW_scrollyBit",
  "stickyBit": "jpCLRW_stickyBit",
  "stuck": "jpCLRW_stuck",
  "viewCode": "jpCLRW_viewCode",
});
